<template>
  <div id="dashboard" class="content">
    <div id="dashboard">
      <div class="block block-rounded block-bordered">
        <ul
          class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
          data-toggle="tabs"
          role="tablist"
        >
          <li class="nav-item" v-for="(item,index) in bis" :key="index">
            <a
              class="nav-link"
              :class="['btabs-animated-fade-'+item.BIS_TYPE ,
              [bis.length>1&&(item.BIS_TYPE==bisType||index==0)?'active':'']]"
              href="javascript:void(0)"
              @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
            >{{item.BIS_NAME}}</a>
          </li>

          <li class="ml-auto nav-main-item add"></li>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
            style="margin-right: 1.25rem"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </ul>
        <div class="block-content tab-content overflow-hidden">
          <div class="tab-pane fade show active" id="btabs-animated-fade-1" role="tabpanel">
            <chargeRate ref="chargeRate"></chargeRate>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-2" role="tabpanel">
            <chargeSystem ref="chargeSystem"></chargeSystem>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-3" role="tabpanel">
            <stopRate ref="stopRate"></stopRate>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-4" role="tabpanel">
            <carportSystem ref="carportSystem"></carportSystem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import chargeRate from "./chargeRate";
import chargeSystem from "./chargeSystem";
import stopRate from "./stopRate";
import carportSystem from "./carportSystem";
export default {
  name: "index",
  data() {
    return {
      bis: [
        {
          BIS_NAME: "充电费率",
          BIS_TYPE: 1
        },
        {
          BIS_NAME: "充电包费率",
          BIS_TYPE: 2
        },
        {
          BIS_NAME: "停车费率",
          BIS_TYPE: 3
        },
        {
          BIS_NAME: "停车包费率",
          BIS_TYPE: 4
        }
      ],
      bisType: 1,
      newUserArr: [],
      buyUserArr: [],
      totalUserArr: [],
      arpuIncomeArr: [],
      userNum: {}
    };
  },
  components: {
    chargeRate,
    chargeSystem,
    stopRate,
    carportSystem
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          // this.getUserNum();
          this.$refs.chargeRate.getList();
          this.$refs.chargeSystem.getList();
          this.$refs.stopRate.getList();
          this.$refs.carportSystem.getList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (this.params.val) {
      this.key = this.searchKye;
    }
    
    this.$refs.chargeRate.getListRateBy(this.$route.params.id);
  },
  methods: {
    showTab(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.bisType = type;
      if (type == 1) {
        this.$refs.chargeRate.getList();
      } else if (type == 2) {
        this.$refs.chargeSystem.getList();
      } else if (type == 3) {
        this.$refs.stopRate.getList();
      } else if (type == 4) {
        this.$refs.carportSystem.getList();
      }
    }
  }
};
</script>